import { getTemplateData } from "./getTemplateData";
import { getTemplate } from "./templates";
export function getDateContent(plan) {
    var _a, _b;
    const templateData = getTemplateData(plan);
    let content = ((_a = getTemplate("content")) === null || _a === void 0 ? void 0 : _a(templateData)) || "";
    if (templateData.scheduleDayIndex === -1) {
        content = ((_b = getTemplate("empty")) === null || _b === void 0 ? void 0 : _b(templateData)) || "";
    }
    return content || "";
}
